/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from '@mui/material';

import ClauseCard from './ClauseCard';
import { highlightedSentence } from '../../hooks/Helper';
import { RootState, useTypedSelector } from '../../redux/store';

interface IProps {
  insights?: any;
}

const Insights = (props: IProps) => {
  const { insights } = props;

  const { instance } = useTypedSelector((state: RootState) => state.draft);

  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [activePara, setActivePara] = React.useState<{
    id: string;
    index: number;
  } | null>();

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const handleSentenceClick = (sentence: string, index: number, id: string) => {
    setActivePara({ id, index });
    highlightedSentence(sentence, instance);
  };

  return (
    <div>
      {!insights?.pending &&
        insights?.data?.map((data: any, index: any) => (
          <Accordion
            key={index}
            onChange={handleChange(data.id)}
            expanded={expanded === data.id}
            disabled={data.insights?.length === 0}
            className="according-class"
          >
            <AccordionSummary>
              <Stack
                direction="row"
                sx={{
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center',
                }}
              >
                <Typography> {data.clause}</Typography>
                <Typography> {data.insights?.length || 0}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              {data.insights?.map((para: string, index: number) => {
                return (
                  <React.Fragment key={index}>
                    {para && (
                      <ClauseCard
                        onClick={() =>
                          handleSentenceClick(para, index, data.id)
                        }
                        key={index}
                        index={index}
                        isActive={
                          activePara?.index === index &&
                          activePara?.id === data.id
                        }
                      >
                        <Typography>{para}</Typography>
                      </ClauseCard>
                    )}
                  </React.Fragment>
                );
              })}
            </AccordionDetails>
          </Accordion>
        ))}
    </div>
  );
};

export default Insights;
